import { productData } from './ProductData';

// El orden de este array debe coincidir con el orden de "navbar_data"
// en los archivos de traducción (public/assets/locales/<idioma>/translation.json),
// ya que el Navbar renderiza los textos por índice.
export const data = [
	{
		to: '/',
		text: 'Inicio',
	},
	{
		to: '/productos',
		text: 'Productos',
		hasDropdown: true,
		dropdownItems: productData.map((product, index) => ({
			to: `/productos?selected=${index}`,
			text: product.title,
			index: index
		}))
	},
	{
		to: '/multiplicacióndesemillas',
		text: 'Servicios',
		hasDropdown: true,
		dropdownItems: [
			{
				to: '/multiplicacióndesemillas',
				text: 'Multiplicación de semillas',
				index: 0
			},
			{
				to: '/planta',
				text: 'Clasificación de semillas',
				index: 1
			}
		]
	},
	{
		to: '/ensayos',
		text: 'Ensayos',
	},
	{
		to: '/nosotros',
		text: '¿Quiénes somos?',
	},
	{
		to: '/signup',
		text: 'Contacto',
	},
];
